import React, { useEffect, useState, useMemo } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { act } from "react-dom/test-utils";

function AssignGradingToClass() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm({
    defaultValues: {
      id: 0,
      name: "",
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [classesData, setClassesData] = useState([]);
  const [acheivementRating, setAcheivementRating] = useState([]);
  const [AcheivementRatingIds, setAcheivementRatingIds] = useState([]);
  const [clearRows, setClearRows] = useState(false);

  useEffect(() => {
    fetchClassesByCenterId();
  }, [triggerRerender]);
  const fetchAcheivementRatingByClassId = async (selectedClassId) => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllAcheivementRatingByClassId?classId=${selectedClassId}&organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAcheivementRating(response.acheivementRatings);
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };
  const handleRowSelected = (state) => {
    const selectedRows = state.selectedRows.map((row) => ({
      id: row.id,
      status: true,
    }));

    const unselectedRows = acheivementRating
      .filter(
        (row) => !state.selectedRows.some((selected) => selected.id === row.id)
      )
      .map((row) => ({
        id: row.id,
        status: false,
      }));
    // Combine selected and unselected rows
    setAcheivementRatingIds([...selectedRows, ...unselectedRows]);
  };
  const fetchClassesByCenterId = async () => {
    try {
      if (savedCenterId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${savedCenterId}`,
          // `Class/GetClassByCenterIdAsync?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const filteredAcheivementRating = acheivementRating.filter((rating) =>
    rating.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Acheivement Rating",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.code,
      sortable: true,
    },
  ];

  const saveData = async () => {
    const data = AcheivementRatingIds.map((AcheivementRatingId) => {
      return {
        OrganizationId: organizationId,
        StudentAchievementRatingId: AcheivementRatingId.id,
        StatusId: AcheivementRatingId.status,
        ClassId: selectedClassId,
      };
    });
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await post(
        "StudentEvaluation/AddUpdateAssignGradingToClassAsync",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        setTriggerRerender((prev) => !prev);
        fetchAcheivementRatingByClassId(selectedClassId);
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assign Grading To Year Group</h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">
                    Year Group<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("classId", null);
                            setSelectedClassId(null);
                            fetchAcheivementRatingByClassId(0);
                          } else {
                            setValue("classId", selectedOption);
                            setSelectedClassId(selectedOption.value);
                            fetchAcheivementRatingByClassId(
                              selectedOption.value
                            );
                          }
                          trigger("classId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.classId && (
                    <small className="text-danger">
                      {errors.classId.message}
                    </small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              {/* <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div> */}
              <DataTable
                columns={columns}
                data={acheivementRating}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                pointerOnHover={true}
                selectableRows
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={clearRows}
                selectableRowSelected={useMemo(
                  () => (row) => row.statusId === true, // Automatically check rows with status 1
                  [classesData]
                )}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default AssignGradingToClass;
